export default __webpack_public_path__ + "static/media/intro-vid.95be0a43.mp4";